var _style, _rect, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaya(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 60",
    style: {
      enableBackground: "new 0 0 128 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0;fill:#FFFFFF;}\n\t.st1{fill:#F58632;}\n\t.st2{fill:#ED4B78;}\n\t.st3{fill:#107ABA;}\n\t.st4{fill:#872C89;}\n\t.st5{fill:#F8BE33;}\n\t.st6{fill:#23AF84;}\n\t.st7{fill:#2556A2;}\n\t.st8{fill:#414141;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    className: "st0",
    width: 128,
    height: 60
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.7,27.8L45.7,27.8c-0.3,0-0.5-0.2-0.5-0.5v-9.9c0-0.3,0.2-0.5,0.5-0.5h0c0.3,0,0.5,0.2,0.5,0.5v9.9 C46.2,27.6,46,27.8,45.7,27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.7,11.5L45.7,11.5c-0.3,0-0.5-0.2-0.5-0.5v-0.8c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5V11 C46.2,11.3,46,11.5,45.7,11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43.6,28.4L43.6,28.4c-0.3,0-0.5-0.2-0.5-0.5V21c0-0.3,0.2-0.5,0.5-0.5h0c0.3,0,0.5,0.2,0.5,0.5v6.9 C44,28.2,43.8,28.4,43.6,28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43.6,9L43.6,9c-0.3,0-0.5-0.2-0.5-0.5V7.8c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5v0.7 C44,8.8,43.8,9,43.6,9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M41.4,28.1L41.4,28.1c-0.3,0-0.5-0.2-0.5-0.5v-2.8c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5v2.8 C41.9,27.9,41.7,28.1,41.4,28.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M41.4,5.1L41.4,5.1c-0.3,0-0.5-0.2-0.5-0.5V3.4C41,3.2,41.2,3,41.4,3l0,0c0.3,0,0.5,0.2,0.5,0.5v1.3 C41.9,4.9,41.7,5.1,41.4,5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M39.3,27.9L39.3,27.9c-0.3,0-0.5-0.2-0.5-0.5v-1.8c0-0.3,0.2-0.5,0.5-0.5h0c0.3,0,0.5,0.2,0.5,0.5v1.8 C39.7,27.7,39.5,27.9,39.3,27.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M37.1,30.9L37.1,30.9c-0.3,0-0.5-0.2-0.5-0.5V28c0-0.3,0.2-0.5,0.5-0.5h0c0.3,0,0.5,0.2,0.5,0.5v2.4 C37.6,30.6,37.4,30.9,37.1,30.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M47.9,26L47.9,26c-0.3,0-0.5-0.2-0.5-0.5V12.6c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5v12.9 C48.3,25.8,48.1,26,47.9,26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M50,24.7L50,24.7c-0.3,0-0.5-0.2-0.5-0.5v-7.7c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5v7.7 C50.5,24.4,50.3,24.7,50,24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52.2,25.1L52.2,25.1c-0.3,0-0.5-0.2-0.5-0.5v-7.9c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5v7.9 C52.6,24.9,52.4,25.1,52.2,25.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M54.3,25.9L54.3,25.9c-0.3,0-0.5-0.2-0.5-0.5v-8.3c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5v8.3 C54.8,25.7,54.6,25.9,54.3,25.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M56.5,27L56.5,27c-0.3,0-0.5-0.2-0.5-0.5l0-8.9c0-0.3,0.2-0.5,0.5-0.5h0c0.3,0,0.5,0.2,0.5,0.5l0,8.9 C56.9,26.8,56.7,27,56.5,27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M58.6,28.4L58.6,28.4c-0.3,0-0.5-0.2-0.5-0.5l0-9.8c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5l0,9.8 C59.1,28.2,58.9,28.4,58.6,28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.8,29.7L60.8,29.7c-0.3,0-0.5-0.2-0.5-0.5V18.6c0-0.3,0.2-0.5,0.5-0.5h0c0.3,0,0.5,0.2,0.5,0.5v10.6 C61.2,29.5,61,29.7,60.8,29.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62.9,31.1L62.9,31.1c-0.3,0-0.5-0.2-0.5-0.5V18.9c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5v11.7 C63.4,30.9,63.2,31.1,62.9,31.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M65.1,32.3L65.1,32.3c-0.3,0-0.5-0.2-0.5-0.5V19c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5v12.8 C65.5,32,65.3,32.3,65.1,32.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M67.2,32.8L67.2,32.8c-0.3,0-0.5-0.2-0.5-0.5V18.5c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5v13.9 C67.7,32.6,67.5,32.8,67.2,32.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M69.4,32.8L69.4,32.8c-0.3,0-0.5-0.2-0.5-0.5V17.2c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5v15.1 C69.8,32.6,69.6,32.8,69.4,32.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M71.5,32.2L71.5,32.2c-0.3,0-0.5-0.2-0.5-0.5V16.2c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5v15.5 C72,32,71.8,32.2,71.5,32.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.7,31.4L73.7,31.4c-0.3,0-0.5-0.2-0.5-0.5V12.9c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5V31 C74.1,31.2,73.9,31.4,73.7,31.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75.8,31.1L75.8,31.1c-0.3,0-0.5-0.2-0.5-0.5V10c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5v20.6 C76.3,30.8,76.1,31.1,75.8,31.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M78,31.4L78,31.4c-0.3,0-0.5-0.2-0.5-0.5V7.8c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5V31 C78.4,31.2,78.2,31.4,78,31.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M80.1,33L80.1,33c-0.3,0-0.5-0.2-0.5-0.5V7.5c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5v25.1 C80.6,32.8,80.4,33,80.1,33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M82.3,17.6L82.3,17.6c-0.3,0-0.5-0.2-0.5-0.5V7.3c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5v9.9 C82.7,17.4,82.5,17.6,82.3,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M82.3,29.8L82.3,29.8c-0.3,0-0.5-0.2-0.5-0.5v-2.6c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5v2.6 C82.7,29.5,82.5,29.8,82.3,29.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M82.3,33L82.3,33c-0.3,0-0.5-0.2-0.5-0.5V31c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5v1.5 C82.7,32.7,82.5,33,82.3,33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M84.4,18.3L84.4,18.3c-0.3,0-0.5-0.2-0.5-0.5v-10c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5v10 C84.9,18.1,84.7,18.3,84.4,18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M84.4,30.8L84.4,30.8c-0.3,0-0.5-0.2-0.5-0.5v-2.2c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5v2.2 C84.9,30.6,84.7,30.8,84.4,30.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M86.6,19.8L86.6,19.8c-0.3,0-0.5-0.2-0.5-0.5V10c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5v9.3 C87,19.6,86.8,19.8,86.6,19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M86.6,31.5L86.6,31.5c-0.3,0-0.5-0.2-0.5-0.5V29c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5v2.1 C87,31.3,86.8,31.5,86.6,31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.7,20.1L88.7,20.1c-0.3,0-0.5-0.2-0.5-0.5v-4.7c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5v4.7 C89.2,19.9,89,20.1,88.7,20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.7,30L88.7,30c-0.3,0-0.5-0.2-0.5-0.5v-0.3c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5v0.3 C89.2,29.8,89,30,88.7,30z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M90.9,19.3L90.9,19.3c-0.3,0-0.5-0.2-0.5-0.5v-0.3c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5v0.3 C91.3,19.1,91.1,19.3,90.9,19.3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M34,38.9c-2.2,0-4.3,1.1-5.5,3c-1.3-2-3.1-3-5.6-3c-1.6,0-3.1,0.6-4.5,1.8c-1.4,1.2-2.1,2.6-2.1,4.2V51 c0,0.7,0.4,1.1,1.1,1.1c0.7,0,1-0.4,1-1.1l0-6.1c0.2-1.1,0.6-2.1,1.5-2.8c0.9-0.8,1.9-1.1,3-1.1c1.2,0,2.3,0.4,3.2,1.3 c0.9,0.8,1.3,1.9,1.3,3.1l0,5.7c0,0.7,0.4,1.1,1,1.1c0.7,0,1.1-0.4,1.1-1.1v-5.7l0-0.4c0.2-1.1,0.6-2.1,1.5-2.8 c0.8-0.7,1.8-1.1,3-1.1c1.2,0,2.3,0.4,3.2,1.3c0.9,0.9,1.3,1.9,1.3,3.1v5.7c0,0.7,0.4,1,1.1,1c0.7,0,1-0.4,1-1v-5.7 c0-1.8-0.7-3.4-2-4.6C37.4,39.5,35.8,38.9,34,38.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M49.3,38.9c-1.8,0-3.4,0.7-4.7,1.9c-1.3,1.3-1.9,2.9-1.9,4.7c0,1.8,0.7,3.4,1.9,4.7c1.3,1.3,2.9,1.9,4.7,1.9 c1.7,0,3.3-0.6,4.5-1.7l0,0.7c0,0.3,0.1,0.6,0.2,0.8c0.2,0.2,0.5,0.3,0.8,0.3c0.7,0,1.1-0.4,1.1-1.1v-5.5c0-1.8-0.7-3.4-1.9-4.8 C52.7,39.6,51.1,38.9,49.3,38.9z M53.8,45.7c0,1.2-0.4,2.3-1.3,3.1c-0.9,0.8-1.9,1.2-3.2,1.2c-1.3,0-2.3-0.4-3.2-1.3 c-0.9-0.9-1.3-1.9-1.3-3.2c0-1.2,0.4-2.3,1.3-3.2c0.9-0.9,2-1.3,3.2-1.3c1.3,0,2.3,0.5,3.2,1.4C53.4,43.3,53.8,44.4,53.8,45.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M70.1,38.9c-0.7,0-1.1,0.4-1.1,1.1l0,6.2c-0.3,2.3-2.1,3.9-4.4,3.9c-1.2,0-2.3-0.4-3.2-1.2 c-0.9-0.8-1.3-1.9-1.3-3.1v-5.8c0-0.7-0.4-1-1.1-1c-0.7,0-1,0.4-1,1v5.8c0,1.8,0.7,3.3,1.9,4.6c1,1,2.2,1.6,3.6,1.8v4 c0,0.5,0.4,0.9,0.9,0.9h0.2c0.5,0,1-0.4,1-0.9v-4c1.2-0.2,2.4-0.8,3.5-1.7c1.4-1.2,2.1-2.6,2.1-4.2v-6.3 C71.2,39.3,70.8,38.9,70.1,38.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M79.8,38.9c-1.8,0-3.4,0.7-4.7,1.9c-1.3,1.3-1.9,2.9-1.9,4.7c0,1.8,0.7,3.4,1.9,4.7c1.3,1.3,2.9,1.9,4.7,1.9 c1.7,0,3.3-0.6,4.5-1.7l0,0.7c0,0.3,0.1,0.6,0.2,0.8c0.2,0.2,0.5,0.3,0.8,0.3c0.7,0,1.1-0.4,1.1-1.1v-5.5c0-1.8-0.7-3.4-1.9-4.8 C83.2,39.6,81.7,38.9,79.8,38.9z M84.3,45.7c0,1.2-0.4,2.3-1.3,3.1c-0.9,0.8-1.9,1.2-3.2,1.2s-2.3-0.4-3.2-1.3 c-0.9-0.9-1.3-1.9-1.3-3.2c0-1.2,0.4-2.3,1.3-3.2c0.9-0.9,2-1.3,3.2-1.3c1.3,0,2.3,0.5,3.2,1.4C83.9,43.3,84.3,44.4,84.3,45.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M100.8,38.9c-1.8,0-3.4,0.7-4.7,1.9c-1.3,1.3-1.9,2.9-1.9,4.7c0,1.8,0.7,3.4,1.9,4.7c1.3,1.3,2.9,1.9,4.7,1.9 c1.7,0,3.3-0.6,4.5-1.7l0,0.7c0,0.3,0.1,0.6,0.2,0.8c0.2,0.2,0.5,0.3,0.8,0.3c0.7,0,1.1-0.4,1.1-1.1v-5.5c0-1.8-0.7-3.4-1.9-4.8 C104.2,39.6,102.6,38.9,100.8,38.9z M105.3,45.7c0,1.2-0.4,2.3-1.3,3.1c-0.9,0.8-1.9,1.2-3.2,1.2c-1.3,0-2.3-0.4-3.2-1.3 c-0.9-0.9-1.3-1.9-1.3-3.2c0-1.2,0.4-2.3,1.3-3.2c0.9-0.9,2-1.3,3.2-1.3c1.3,0,2.3,0.5,3.2,1.4C104.8,43.3,105.3,44.4,105.3,45.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M110.5,36.8c0.8,0,1.2-0.5,1.2-1.3c0-0.8-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.3C109.3,36.3,109.7,36.8,110.5,36.8z "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 91,
    cy: 50.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M110.6,38.8h-0.2c-0.5,0-1,0.6-1,1.2V51c0,0.7,0.4,1.2,1,1.2h0.2c0.5,0,1-0.6,1-1.2V40.1 C111.6,39.4,111.1,38.8,110.6,38.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaya);
export default __webpack_public_path__ + "static/media/maya.4365b7550a2207589deebda32566ce8f.svg";
export { ForwardRef as ReactComponent };